import { TextareaProps } from '@apia/theme';
import { ValidatedCollectorField } from '../ValidatedCollectorField';
import { getLabelName, getLabelTooltip } from '@apia/util';
import { AutogrowTextarea } from '../../components/AutogrowTextarea';

export class CollectorAutogrowTextarea extends ValidatedCollectorField<
  string,
  Omit<TextareaProps, 'name'>
> {
  type = 'autogrowtextarea';

  Component = () => {
    const rules = this.useValidationRules();
    const validationFunction = this.useValidationFunction();
    const props = this.useProperties();

    return (
      <AutogrowTextarea
        {...props}
        initialValue={this.config.initialValue}
        name={this.name}
        validationFunction={validationFunction}
        validationRules={rules}
        label={getLabelName(this.label)}
        title={getLabelTooltip(this.label)}
        removeOnUnmount={false}
        avoidRegisterIfExists
      />
    );
  };
}
